// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"c75e6c9d","126":"2d59902b","289":"883e932d","522":"1924732e","535":"1052cce5"}[chunkId] + ".chunk.js";
};